import { motion } from "motion/react";
import Link from "next/link";

interface MenuItemProps {
  href: string;
  text: string;
}

export const MenuItemWithAnimation = ({ href, text }: MenuItemProps) => {
  return (
    <motion.li
      className="nav-item"
      style={{
        position: "relative",
        overflow: "hidden",
        padding: "0.5rem 1rem",
      }}
      whileHover="hover"
      whileTap={{ scale: 0.9 }}
    >
      <Link href={href} className="nav-link">
        {text}
      </Link>
      <motion.div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: "2px",
          background: "#12E507FF",
          transformOrigin: "left",
        }}
        initial={{ scaleX: 0 }}
        variants={{
          hover: {
            scaleX: 1,
            transition: {
              duration: 0.4,
              ease: "easeInOut",
            },
          },
        }}
      />
    </motion.li>
  );
};
